import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { config } from '@/config';
import { KYCTable } from '@/components/dashboard/kyc/kyc-table';

export default function KycPage(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>KYC | Dashboard | {config.site.name}</title>
      </Helmet>
      <Stack spacing={3}>
        <div>
          <Typography variant="h4">Quản Lý Danh Sách KYC</Typography>
        </div>
        <KYCTable />
      </Stack>
    </>
  );
}
